import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import useMedia from "use-media";
import { getMemberRelationList } from "../../../const";
import common from "../../../resources/js/common/common";
import commonUtil from "../../../common/commonUtil";
import { GoldCheckBox } from "../../atoms/goldCheckBox";
import { Button } from "../../atoms/button";
import { Label } from "../../atoms/label";
import { ModalClose } from "../../atoms/modalClose";
import { PrivilegeIcon } from "../../atoms/privilegeIcon";
import { ErrorMassage } from "../../molecules/errorMassage";
import messageConst from '../../../const/messageConst';

const ChooseRightPopupContainer = (props) => {
    const {
        login,
        state,
        right,
        inputUserInfo,
        setRight,
        onClickClosePopupWindow,
        setRightList,
        membershipSearchParam } = props;

    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [relationList, setRelationList] = useState([]);
    const popupRef = useRef(null);

    const dataList = state.rightList ? state.rightList : [];
    const [rightTypeList, setRightTypeList] = useState([
        { type: "empty", openFlg: false }, // ホームFL
        { type: "gold", openFlg: false },
        { type: "red", openFlg: false },
        { type: "white", openFlg: false },
        { type: "blue", openFlg: false }
    ]);

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [temporaryErrorInfo, setTemporaryErrorInfo] = useState({ errorMessage: "", errorFlg: false, });

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        // 会員との関係一覧取得
        common.doPost(getMemberRelationList, {}, afterGetMemberRelationList);
    }, [useMediaFlag]);

    useEffect(() => {
        setRightTypeList([
            { type: "empty", openFlg: false }, // ホームFL
            { type: "gold", openFlg: false },
            { type: "red", openFlg: false },
            { type: "white", openFlg: false },
            { type: "blue", openFlg: false }
        ]);
        setErrorInfo({ errorMessage: null, errorFlg: false, });
    }, [state.membershipPopup]);

    // 会員との関係一覧取得後処理
    const afterGetMemberRelationList = (res) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            setRelationList(commonUtil.getSelectList(data.relationList, "relationCd", "relationName", true, "選択する"));
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg });
    }

    // 権利一覧を展開
    const onClickOpen = (type) => {
        let newList = [];
        rightTypeList.forEach(value => {
            if (value.type === type) value.openFlg = !value.openFlg;
            newList.push(value);
        });
        setRightTypeList(newList);
    }

    // チェック状態変更
    const onClickCheckForm = (id) => {
        let target = document.getElementById(id);
        target.click();
    }
    const onchangeCheck = (dateIndex, dateChecked) => {
        let checkedCnt = dataList.filter(value => value.checked && value.nightsNum === state.nightsNum).length;
        if (checkedCnt < membershipSearchParam.roomCnt || (checkedCnt === membershipSearchParam.roomCnt && dateChecked)) {
            let newList = [];
            dataList.forEach((value, index) => {
                if (index == dateIndex) {
                    value.nightsNum = value.checked ? -1 : state.nightsNum;
                    value.checked = !value.checked;
                }
                newList.push(value);
            })
            setRightList(newList);
        }
    }

    // 決定
    const onClickDecide = () => {
        let newStayList = [];
        let selectRightList = [];
        dataList.forEach(value => {
            if (value.nightsNum === state.nightsNum) {
                selectRightList.push({ shokaKenriIro: value.kbn, shokaKenriDate: value.date,senyuDatHyojiOkFlg:value.senyuDatHyojiOkFlg,senyuDatHyojiDaitaiStr:value.senyuDatHyojiDaitaiStr});
            }
        })
        if (selectRightList.length === right[state.nightsNum]?.senyuDate?.length) {
            right.forEach((value, index) => {
                if (index === state.nightsNum) {
                    newStayList.push({ senyuDate: selectRightList, senyuKenriIro: value.senyuKenriIro, siyoDate: value.siyoDate, senyuDatHyojiOkFlg:value.senyuDatHyojiOkFlg, stayNum: value.stayNum});
                } else {
                    newStayList.push(value);
                }
            })
            setRight(newStayList);
            onClickClosePopupWindow();
            setErrorInfo({ errorMessage: null, errorFlg: false, });
        } else {
            let errText = "消化権利を" + right[state.nightsNum]?.senyuDate?.length + "つお選びください。";
            setErrorInfo({ errorMessage: [errText], errorFlg: true, });
        }
    }

    // 閉じる
    const onClickClose = () => {
        let newList = [];
        dataList.forEach((value, index) => {
            value.checked = false;
            value.nightsNum = -1;
            newList.push(value);
        })
        setRightList(newList);
        onClickClosePopupWindow();
    }

    return (
        <div className={state.membershipPopup ? "popupIsShow" : "popup"} id="js-popup">
            <div ref={popupRef} className={isMobilePhone ? "rightPopupInner_media" : "rightPopupInner"}>
                <div className="popupHeader">
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClickClose()} />
                    <h4 className="popupInnerText" >権利選択</h4>
                </div>
                <div style={isMobilePhone ? style.tableMobile : style.table}>
                    <div className="rightDispAreaBorder">
                        <Label label="宿泊日" className="selectRightText" />
                        <div className="rightItem">
                            <div className="rightImage">
                                <PrivilegeIcon className={state.kbn} />
                            </div>
                            <Label label={state.siyoDate ? commonUtil.getStringFromDateJpnMembership(state.siyoDate) : ""} className="" />
                        </div>
                    </div>
                    <div className="rightDispAreaBorder">
                        <Label label={"消化権利を" + right[state.nightsNum]?.senyuDate?.length + "つお選びください。"} className="selectRightText" />
                        <div className={dataList.filter(right => right.kbn === "empty" && right.riyoDateFlg).length === 0 ? "hiddenItem" : "rightListWrap"}>
                            <div className={rightTypeList[0].openFlg ? "rightTypeOpen" : "rightTypeClose"} onClick={() => onClickOpen("empty")}>
                                <div className="selectRightImage">
                                    <PrivilegeIcon className="empty" />
                                </div>
                                <Label label="ホームフローティング" className="" />
                            </div>
                            <div className={state.kbn === "red" && inputUserInfo && inputUserInfo.relationCd != (relationList && relationList.find(relationInfo => relationInfo.value == "会員本人") && relationList.find(relationInfo => relationInfo.value == "会員本人").id) ? "descHomeFl" : "hiddenItem"} >{messageConst.HOME_FL_INFO_RED_MESSAGE}</div>
                            <div className={rightTypeList[0].openFlg ? "rightList" : "hiddenItem"}>
                                {dataList.filter(right => right.kbn === "empty").map((value, index) =>
                                    value.riyoDateFlg ?
                                    <div className={value.nightsNum != -1 && value.nightsNum != state.nightsNum ? "rightItemDisabled" : "rightItem"}>
                                        <GoldCheckBox
                                            checkAreaStyle={isMobilePhone ? style.divItemTitleStyleSp : style.divItemTitleStyle}
                                            id={"empty" + index}
                                            name="right"
                                            className="empty"
                                            checked={value.checked && value.nightsNum == state.nightsNum}
                                            disabled={value.nightsNum != -1 && value.nightsNum != state.nightsNum}
                                            onChange={() => onchangeCheck(value.index, value.checked)}
                                        />
                                        <div className="rightLabel" onClick={() => onClickCheckForm("empty" + index)} >
                                            <div className="rightImageList">
                                                <PrivilegeIcon className="empty" />
                                            </div>
                                            {
                                                value.senyuDatHyojiOkFlg ?
                                                <Label label={commonUtil.getStringFromDateJpnMembership(value.date)} className="" />
                                                :
                                                <Label label={value.senyuDatHyojiDaitaiStr} />
                                            }
                                        </div>
                                    </div>
                                    :
                                    null)}
                            </div>
                        </div>
                        <div className={dataList.filter(right => right.kbn === "gold" && right.riyoDateFlg).length === 0 ? "hiddenItem" : "rightListWrap"}>
                            <div className={rightTypeList[1].openFlg ? "rightTypeOpen" : "rightTypeClose"} onClick={() => onClickOpen("gold")}>
                                <div className="selectRightImage">
                                    <PrivilegeIcon className="gold" />
                                </div>
                                <Label label="権利／ゴールド" className="" />
                            </div>
                            <div className={rightTypeList[1].openFlg ? "rightList" : "hiddenItem"}>
                                {dataList.filter(right => right.kbn === "gold").map((value, index) =>
                                    value.riyoDateFlg ?
                                    <div className={value.nightsNum != -1 && value.nightsNum != state.nightsNum ? "rightItemDisabled" : "rightItem"}>
                                        <GoldCheckBox
                                            checkAreaStyle={isMobilePhone ? style.divItemTitleStyleSp : style.divItemTitleStyle}
                                            id={"gold" + index}
                                            name="right"
                                            className="gold"
                                            checked={value.checked && value.nightsNum == state.nightsNum}
                                            disabled={value.nightsNum != -1 && value.nightsNum != state.nightsNum}
                                            onChange={() => onchangeCheck(value.index, value.checked)}
                                        />
                                        <div className="rightLabel" onClick={() => onClickCheckForm("gold" + index)} >
                                            <div className="rightImageList">
                                                <PrivilegeIcon className="gold" />
                                            </div>
                                            {
                                                value.senyuDatHyojiOkFlg ?
                                                <Label label={commonUtil.getStringFromDateJpnMembership(value.date)} className="" />
                                                :
                                                <Label label={value.senyuDatHyojiDaitaiStr}/>
                                            }
                                        </div>
                                    </div>
                                    :
                                    null)}
                            </div>
                        </div>
                        <div className={dataList.filter(right => right.kbn === "red" && right.riyoDateFlg).length === 0 ? "hiddenItem" : "rightListWrap"}>
                            <div className={rightTypeList[2].openFlg ? "rightTypeOpen" : "rightTypeClose"} onClick={() => onClickOpen("red")}>
                                <div className="selectRightImage">
                                    <PrivilegeIcon className="red" />
                                </div>
                                <Label label="権利／レッド" className="" />
                            </div>
                            <div className={rightTypeList[2].openFlg ? "rightList" : "hiddenItem"}>
                                {dataList.filter(right => right.kbn === "red").map((value, index) =>
                                    value.riyoDateFlg ?
                                    <div className={value.nightsNum != -1 && value.nightsNum != state.nightsNum ? "rightItemDisabled" : "rightItem"}>
                                        <GoldCheckBox
                                            checkAreaStyle={isMobilePhone ? style.divItemTitleStyleSp : style.divItemTitleStyle}
                                            id={"red" + index}
                                            name="right"
                                            className="red"
                                            checked={value.checked && value.nightsNum == state.nightsNum}
                                            disabled={value.nightsNum != -1 && value.nightsNum != state.nightsNum}
                                            onChange={() => onchangeCheck(value.index, value.checked)}
                                        />
                                        <div className="rightLabel" onClick={() => onClickCheckForm("red" + index)}>
                                            <div className="rightImageList">
                                                <PrivilegeIcon className="red" />
                                            </div>
                                            {
                                                value.senyuDatHyojiOkFlg ?
                                                <Label label={commonUtil.getStringFromDateJpnMembership(value.date)} className="" />
                                                :
                                                <Label label={value.senyuDatHyojiDaitaiStr}/>
                                            }
                                        </div>
                                    </div>
                                    :
                                    null)}
                            </div>
                        </div>
                        <div className={dataList.filter(right => right.kbn === "white" && right.riyoDateFlg).length === 0 ? "hiddenItem" : "rightListWrap"}>
                            <div className={rightTypeList[3].openFlg ? "rightTypeOpen" : "rightTypeClose"} onClick={() => onClickOpen("white")}>
                                <div className="selectRightImage">
                                    <PrivilegeIcon className="white" />
                                </div>
                                <Label label="権利／ホワイト" className="" />
                            </div>
                            <div className={rightTypeList[3].openFlg ? "rightList" : "hiddenItem"}>
                                {dataList.filter(right => right.kbn === "white").map((value, index) =>
                                    value.riyoDateFlg ?
                                    <div className={value.nightsNum != -1 && value.nightsNum != state.nightsNum ? "rightItemDisabled" : "rightItem"}>
                                        <GoldCheckBox
                                            checkAreaStyle={isMobilePhone ? style.divItemTitleStyleSp : style.divItemTitleStyle}
                                            id={"white" + index}
                                            name="right"
                                            className="white"
                                            checked={value.checked && value.nightsNum == state.nightsNum}
                                            disabled={value.nightsNum != -1 && value.nightsNum != state.nightsNum}
                                            onChange={() => onchangeCheck(value.index, value.checked)}
                                        />
                                        <div className="rightLabel" onClick={() => onClickCheckForm("white" + index)}>
                                            <div className="rightImageList">
                                                <PrivilegeIcon className="white" />
                                            </div>
                                            {
                                                value.senyuDatHyojiOkFlg ?
                                                <Label label={commonUtil.getStringFromDateJpnMembership(value.date)} className="" />
                                                :
                                                <Label label={value.senyuDatHyojiDaitaiStr}/>
                                            }
                                        </div>
                                    </div>
                                    :
                                    null)}
                            </div>
                        </div>
                        <div className={dataList.filter(right => right.kbn === "blue" && right.riyoDateFlg).length === 0 ? "hiddenItem" : "rightListWrap"}>
                            <div className={rightTypeList[4].openFlg ? "rightTypeOpen" : "rightTypeClose"} onClick={() => onClickOpen("blue")}>
                                <div className="selectRightImage">
                                    <PrivilegeIcon className="blue" />
                                </div>
                                <Label label="権利／ブルー" className="" />
                            </div>
                            <div className={rightTypeList[4].openFlg ? "rightList" : "hiddenItem"}>
                                {dataList.filter(right => right.kbn === "blue").map((value, index) =>
                                    value.riyoDateFlg ?
                                    <div className={value.nightsNum != -1 && value.nightsNum != state.nightsNum ? "rightItemDisabled" : "rightItem"}>
                                        <GoldCheckBox
                                            checkAreaStyle={isMobilePhone ? style.divItemTitleStyleSp : style.divItemTitleStyle}
                                            id={"blue" + index}
                                            name="right"
                                            className="blue"
                                            checked={value.checked && value.nightsNum == state.nightsNum}
                                            disabled={value.nightsNum != -1 && value.nightsNum != state.nightsNum}
                                            onChange={() => onchangeCheck(value.index, value.checked)}
                                        />
                                        <div className="rightLabel" onClick={() => onClickCheckForm("blue" + index)}>
                                            <div className="rightImageList">
                                                <PrivilegeIcon className="blue" />
                                            </div>
                                            {
                                                value.senyuDatHyojiOkFlg ?
                                                <Label label={commonUtil.getStringFromDateJpnMembership(value.date)} className="" />
                                                :
                                                <Label label={value.senyuDatHyojiDaitaiStr}/>
                                            }
                                        </div>
                                    </div>
                                    :
                                    null)}
                            </div>
                        </div>
                    </div>
                    <div className="rightColorList">
                        <div style={{ display: "flex" }}>
                            <div className="selectRightImageDescription">
                                <PrivilegeIcon className="gold" />
                            </div>
                            <Label label={"：ゴールド"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                        </div>
                        <div style={{ display: "flex" }}>
                            <div className="selectRightImageDescription">
                                <PrivilegeIcon className="red" />
                            </div>
                            <Label label={"：レッド"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                        </div>
                        <div style={{ display: "flex" }}>
                            <div className="selectRightImageDescription">
                                <PrivilegeIcon className="white" />
                            </div>
                            <Label label={"：ホワイト"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                        </div>
                        <div style={{ display: "flex" }}>
                            <div className="selectRightImageDescription">
                                <PrivilegeIcon className="blue" />
                            </div>
                            <Label label={"：ブルー"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                        </div>
                    </div>
                </div>
                <div style={errorInfo.errorFlg ? style.errorDiv : { display: "none" }}>
                    <ErrorMassage style={style.errorMassage} data={errorInfo.errorMessage} />
                </div>
                <div className="buttonArea2 buttonAreaSticky" >
                    <Button className="conditionSearch" onClick={onClickDecide} buttonClassName="buttonText" buttonText="決定" />
                </div>
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};
const style = {
    table: {
        display: "block",
        width: "70%",
        margin: "20px auto",
        borderCollapse: "collapse",
        marginBottom: "0px",
        marginBottom: "0px",
    },
    tableMobile: {
        display: "block",
        width: "90%",
        margin: "20px auto",
        borderCollapse: "collapse",
        marginBottom: "0px",
        marginBottom: "0px",
    },
    divItemTitleStyle: {
        margin: "0px 0px 10px 4px",
        color: "#696969",
        justifyContent: "left",
    },
    divItemTitleStyleSp: {
        textAlign: "left",
        padding: "10px 0px 20px 4px",
        color: "#696969",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold",
        margin: "0px 0px 10px 0px",
    },
}

const mapStateToProps = (state) => {
    return {
        login: state.login,
        checkIn: state.checkIn,
        inputUserInfo: state.inputUserInfo,
        right: state.right,
        membershipSearchParam: state.membershipSearchParam
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setRight: (item) => {
            dispatch({ type: "RIGHT", payload: { right: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(ChooseRightPopupContainer);